import { useParams } from 'react-router-dom';
import ProductKeywordsUpload from '../pages/Keywords/subPages/ProductKeywordsUpload';
import KeywordsUpload from '../pages/Keywords/subPages/KeywordsUpload';
import KeywordCategoriesUpload from '../pages/Keywords/subPages/KeywordCategoriesUpload';
import TitleSplitUpload from 'pages/ProductTitles/subPages/TitleSplitUpload';
import AliasesUpload from 'pages/ProductTitles/subPages/AliasesUpload';
import { useGetUserInfoSelector } from 'core/redux/selectors/authSelectors';
import * as productManagement from 'pages/ProductManagement';
import * as keywordManagement from 'pages/Keywords';

const UploadRouter = () => {
    const { page } = useParams();
    const userInfo = useGetUserInfoSelector();

    const redirectReadonlyKeyword = (component: JSX.Element, page: string) => {
        const readonly = !userInfo?.user_groups?.includes(18);

        if (readonly) {
            window.location.href = `/${keywordManagement.PATH}/${page}`;
            return null;
        }

        return component;
    };

    const redirectReadonlyTitle = (component: JSX.Element, page: string) => {
        const readonly = !userInfo?.user_groups?.includes(20);

        if (readonly) {
            window.location.href = `/${productManagement.PATH}/${page}`;
            return null;
        }

        return component;
    };

    switch (page) {
        case 'search':
        case 'banner':
            return redirectReadonlyKeyword(<KeywordsUpload />, page);
        case 'ean-keywords':
            return redirectReadonlyKeyword(<ProductKeywordsUpload />, page);
        case 'keywords-categories':
            return redirectReadonlyKeyword(<KeywordCategoriesUpload />, page);
        case 'splits':
            return redirectReadonlyTitle(<TitleSplitUpload />, page);
        case 'aliases':
            return redirectReadonlyTitle(<AliasesUpload />, page);
    }

    return null;
};

export default UploadRouter;
